import type { ShiftsRow } from 'modules/shift_management/lib/types'

interface Props {
  shiftsRow: ShiftsRow
}

interface Result {
  workingHours: number
  frequency: string
  workingWeekDays: string
}

const useContractDetails = ({ shiftsRow }: Props): Result => {
  const referenceContract = shiftsRow.referenceContract

  if (!referenceContract) {
    return {
      workingHours: 0,
      frequency: 'week',
      workingWeekDays: 'monday,tuesday,wednesday,thursday,friday',
    }
  }

  return {
    workingHours: referenceContract.workingHours / 100,
    frequency: referenceContract.workingHoursFrequency,
    workingWeekDays: referenceContract.workingWeekDays,
  }
}

export default useContractDetails
